import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
var _effectorFileName = "/builds/gmini/front-api-call-service/src/ApiCallService.ts";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.keys.js";
import { forward, createEvent } from 'effector';
import { useStore, useStoreMap } from 'effector-react';
import { dec, inc, prop } from 'ramda';
import { createJsendResponseValidator } from './Jsend';
export var IO_TS_VALIDATION_OFF = Boolean(process.env.IO_TS_VALIDATION_OFF);
export var ApiCallService;

(function (_ApiCallService) {
  var fail = _ApiCallService.fail = createEvent('fail', {
    sid: "xlafd4"
  });

  function create(options) {
    var domain = options.parentDomain.domain(options.name, {
      name: "domain",
      sid: "twlxtl"
    });
    var run = domain.effect('run', {
      name: "run",
      sid: "6oxvdt"
    });
    forward({
      ɔ: {
        from: run.fail.map(function (_ref) {
          var error = _ref.error,
              params = _ref.params;
          return {
            error: error,
            params: params,
            name: run.compositeName.fullName
          };
        }),
        to: fail
      },
      config: {
        sid: "lb4s31"
      }
    });
    var trigger = domain.event('trigger', {
      name: "trigger",
      sid: "kc4to5"
    });
    forward({
      ɔ: {
        from: run,
        to: trigger
      },
      config: {
        sid: "lsq72l"
      }
    });

    var _createJsendResponseV = createJsendResponseValidator(options.result, IO_TS_VALIDATION_OFF),
        validate = _createJsendResponseV.validate,
        toPromise = _createJsendResponseV.toPromise;

    var getKeyOption = options.getKey;
    var getKey = typeof getKeyOption === 'function' ? getKeyOption : function () {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (// eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-ignore
        getKeyOption.map(function (key) {
          return payload[key];
        }).join(':')
      );
    };

    function createContext(contextOptions) {
      var name = typeof contextOptions == 'string' ? contextOptions : contextOptions === null || contextOptions === void 0 ? void 0 : contextOptions.name;
      return ApiCallServiceContext.create({
        name: name,
        parentDomain: domain,
        run: run,
        getKey: getKey
      });
    }

    function use(handler) {
      run.use(handler);
    }

    use.getCurrent = run.use.getCurrent;
    return {
      trigger: trigger,
      done: run.done,
      doneData: run.doneData,
      fail: run.fail,
      failData: run.failData,
      "finally": run["finally"],
      getKey: getKey,
      use: use,
      defaultContext: createContext({
        name: 'Default'
      }),
      createContext: createContext,
      validate: validate,
      toPromise: toPromise
    };
  }

  _ApiCallService.create = create;
})(ApiCallService || (ApiCallService = {}));

export var ApiCallServiceContext;

(function (_ApiCallServiceContext) {
  function create(_ref2) {
    var name = _ref2.name,
        parentDomain = _ref2.parentDomain,
        handler = _ref2.run,
        getKey = _ref2.getKey;
    var domain = parentDomain.domain(name, {
      name: "domain",
      sid: "ozodjv"
    });
    var submit = domain.event('submit', {
      name: "submit",
      sid: "-sttpxr"
    });
    var reset = domain.event('reset', {
      name: "reset",
      sid: "-yjxili"
    });
    var run = domain.effect({
      name: 'run',
      handler: handler
    }, {
      name: "run",
      sid: "-2amr41"
    });
    forward({
      ɔ: {
        from: submit,
        to: run
      },
      config: {
        sid: "kjm5i4"
      }
    });

    var setCount = function setCount(transform) {
      return function (map, payload) {
        var key = getKey(payload);
        var count = map[key] || 0;
        return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, transform(count)));
      };
    };

    var pendingMap$ = domain.store({}, {
      ɔ: {
        name: 'pendingMap$'
      },
      name: "pendingMap$",
      sid: "-cywqxi"
    }).on(run, setCount(inc)).on(run["finally"].map(prop('params')), setCount(dec)).map(function (map) {
      return Object.keys(map).reduce(function (acc, key) {
        var value = map[key];
        acc[key] = !!value;
        return acc;
      }, {});
    });

    function usePending(payload) {
      var key = typeof payload == 'string' ? payload : getKey(payload);
      return useStoreMap({
        store: pendingMap$,
        keys: [key],
        fn: function fn(map, _ref3) {
          var _ref4 = _slicedToArray(_ref3, 1),
              key = _ref4[0];

          return !!map[key];
        }
      });
    }

    var pending$ = domain.store(0, {
      ɔ: {
        name: 'pending$'
      },
      name: "pending$",
      sid: "e4r6hh"
    }).on(run, inc).on(run["finally"], dec).map(Boolean);

    function useCommonPending() {
      return useStore(pending$);
    }

    var errors$ = domain.store({}, {
      ɔ: {
        name: 'errors$'
      },
      name: "errors$",
      sid: "vgg9sb"
    }).on(submit, function (map, payload) {
      var key = getKey(payload);

      if (map[key]) {
        var newMap = _objectSpread({}, map);

        delete newMap[key];
        return newMap;
      }
    }).on(run.fail, function (map, result) {
      var key = getKey(result.params);
      return _objectSpread(_objectSpread({}, map), {}, _defineProperty({}, key, result));
    }).reset(reset);

    function useError(payload) {
      var key = typeof payload == 'string' ? payload : getKey(payload);
      return useStoreMap({
        store: errors$,
        keys: [key],
        fn: function fn(map, _ref5) {
          var _ref6 = _slicedToArray(_ref5, 1),
              key = _ref6[0];

          return map[key] || null;
        }
      });
    }

    var lastError$ = domain.store(null, {
      ɔ: {
        name: 'lastError$'
      },
      name: "lastError$",
      sid: "-2xtn61"
    }).on(run.fail, function (_, result) {
      return result;
    }).reset(reset);

    function useLastError() {
      return useStore(lastError$);
    }

    function context(payload) {
      return run(payload);
    }

    context.domain = domain;
    context.submit = submit;
    context.done = run.done;
    context.doneData = run.doneData;
    context.fail = run.fail;
    context.failData = run.failData;
    context["finally"] = run["finally"];
    context.reset = reset;
    context.pending$ = pending$;
    context.pendingMap$ = pendingMap$;
    context.errors$ = errors$;
    context.lastError$ = lastError$;
    context.useCommonPending = useCommonPending;
    context.usePending = usePending;
    context.useError = useError;
    context.useLastError = useLastError;
    return context;
  }

  _ApiCallServiceContext.create = create;
})(ApiCallServiceContext || (ApiCallServiceContext = {}));